var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPackedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.174,
    height: 51.224,
    viewBox: "0 0 46.174 51.224",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-box",
    "data-name": "Icon feather-box",
    transform: "translate(-3 -1.437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M47.674,36.578V17.389a4.8,4.8,0,0,0-2.4-4.149L28.486,3.646a4.8,4.8,0,0,0-4.8,0L6.9,13.24a4.8,4.8,0,0,0-2.4,4.149V36.578a4.8,4.8,0,0,0,2.4,4.149l16.79,9.594a4.8,4.8,0,0,0,4.8,0l16.79-9.594a4.8,4.8,0,0,0,2.4-4.149Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#455cfd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M4.905,10.44,25.844,22.553,46.784,10.44",
    transform: "translate(0.243 4.455)",
    fill: "none",
    stroke: "#455cfd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M18,42.177V18",
    transform: "translate(8.087 8.984)",
    fill: "none",
    stroke: "#455cfd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackedIcon);
export default __webpack_public_path__ + "static/media/packed-icon.458354da6bc5c13fa1612ba3aa3ac7d4.svg";
export { ForwardRef as ReactComponent };